import React, {Dispatch, SetStateAction} from 'react';
import s from "./AddDoc.module.css";
import classnames from "classnames";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {validateFile} from "../../helpers/validateFile/validateFile";
import attachedDoc from "../../assets/img/personalAccount/document.svg";
import delete_document from "../../assets/img/personalAccount/delete_doc.svg";
import {ReactComponent as Plus} from "../../assets/img/personalAccount/plus.svg";
import invoiceImg from "../../assets/img/personalAccount/invoice.svg";

type InvoiceType = {
    name: string,
    data: string
}

type AddDocPropsType = {
    setDocumentErrorModalText?: Dispatch<SetStateAction<string | null>>
    setIsDocumentErrorModalOpen?: Dispatch<SetStateAction<boolean | null>>
    setFieldValue?: any
    invoice?: InvoiceType
}

const AddDoc = (props: AddDocPropsType) => {

    const {
        setDocumentErrorModalText,
        setIsDocumentErrorModalOpen,
        setFieldValue,
        invoice
    } = props

    return (
        <div className={s.docs_wrapper}>
            <div className={classnames(s.row_doc, s.flex_start)}>
                <div className={s.invoice_img}>
                    <img src={invoiceImg} alt=""/>
                </div>
                <div>
                    <p className={s.invoice_title}>Add an invoice (optional)</p>
                    <p className={s.invoice_desc}>Appropriate format: JPEG, JPG, PNG, TXT,
                        PDF.</p>
                </div>
            </div>
            <div className={s.attached_file_wrapper}>
                <div className={s.button_wrapper}>
                    <TransparentButton
                        isPersonalAccountBtn
                        title={"Add file"}
                        small
                        icon={<Icon component={() => <Plus/>} rev={undefined}/>}
                        onClick={(e: any) => {
                            e.preventDefault()
                            // @ts-ignore
                            document.getElementById('hiddenInvoice').click()
                        }}
                    />
                    <input type="file"
                           accept=".png, .jpg, .jpeg, .pdf, .txt"
                           id={"hiddenInvoice"}
                           className={s.hidden_input}
                           onChange={async (event) => {

                               if (!event.currentTarget.files?.[0]) {
                                   return;
                               }

                               try {
                                   const fileData = await validateFile(
                                       event,
                                       setDocumentErrorModalText,
                                       setIsDocumentErrorModalOpen)
                                       setFieldValue("invoice", fileData);
                               } catch (error) {
                                   console.log(error)
                               }
                           }}
                    />
                </div>
                <div className={s.attached_file}>
                    {
                        invoice?.name && <img src={attachedDoc} alt=""/>
                    }
                    {
                        // @ts-ignore
                        <span className={s.invoice_doc_name}>{invoice?.name}</span>
                    }
                    {
                        // @ts-ignore
                        invoice?.name &&
                        <img onClick={() => {
                            // @ts-ignore
                            document.getElementById("hiddenInvoice").value = ""
                            setFieldValue("invoice", "")
                        }}
                             className={s.delete_doc}
                             src={delete_document}
                             alt=""
                        />
                    }
                </div>
            </div>
        </div>
    );
};

export default AddDoc;
